import React, { Component } from "react";
import CookieSelector from "../components/Cookies/CookieSelector";
import dynamicPortal from "../utils/dynamicPortal";

export class CookiesPortal extends Component {
  render() {
    return dynamicPortal.load(".js-react-cookies", (config) => (
      <CookieSelector {...config} />
    ));
  }
}

export default CookiesPortal;



// WEBPACK FOOTER //
// ./src/portals/CookiesPortal.js